import { render } from "./BecomeManagerMobile.vue?vue&type=template&id=7afbde1f"
import script from "./BecomeManagerMobile.vue?vue&type=script&lang=js"
export * from "./BecomeManagerMobile.vue?vue&type=script&lang=js"

import "./BecomeManagerMobile.vue?vue&type=style&index=0&id=7afbde1f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__